export default __webpack_public_path__ + "33c64a66a342776190c538ee4d4eaf97.ttf";